import React from "react";
import Text from "../components/atoms/Text";
import Button from "../components/atoms/Button";
import products from "../data/products.json";
import { useUser } from "../context/UserContext";
import socialMedias from "../assets/Social Medias.png";

function formatCurrency(value) {
  return `$${Number(value).toFixed(2)}`;
}

export default function Wishlist() {
  const { currentUser, isAuthenticated, isLoadingUser, addToCart, toggleWishlist } = useUser();
  const wishlistProducts = products.filter((product) =>
    currentUser?.wishlist?.includes(product.id),
  );

  if (isLoadingUser) {
    return null;
  }

  if (!isAuthenticated) {
    return (
        <div style={{ padding: "60px 300px 100px", backgroundColor: "var(--white)" }}>
        <Text size="px32" weight="w600" color="gray9">
          Please sign in to view your wishlist.
        </Text>
      </div>
    );
  }

  return (
    <div className="wishlist-page" style={{ padding: "40px 300px 100px", backgroundColor: "var(--white)" }}>
      <div
        className="wishlist-shell"
        style={{
          border: "1px solid var(--gray1)",
          borderRadius: "8px",
          backgroundColor: "var(--white)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "24px",
            borderBottom: "1px solid var(--gray1)",
            textAlign: "center",
          }}
        >
          <Text size="px32" weight="w600" color="gray9">
            My Wishlist
          </Text>
        </div>

        {wishlistProducts.length === 0 ? (
          <div style={{ padding: "40px 28px" }}>
            <Text size="px18" weight="w400" color="gray5">
              Your wishlist is empty.
            </Text>
          </div>
        ) : (
          <>
            <div
              className="wishlist-head"
              style={{
                display: "grid",
                gridTemplateColumns: "2.1fr 1fr 1fr 0.95fr 40px",
                padding: "16px 28px",
                backgroundColor: "var(--white)",
                borderBottom: "1px solid var(--gray1)",
                alignItems: "center",
              }}
            >
              {["Product", "Price", "Stock Status", "", ""].map((heading, index) => (
                <Text
                  key={`${heading}-${index}`}
                  size="px12"
                  weight="w500"
                  color="gray5"
                  extraStyles={{ textTransform: "uppercase", textAlign: "start" }}
                >
                  {heading}
                </Text>
              ))}
            </div>

            {wishlistProducts.map((item) => {
              const isInStock = true;

              return (
                <div
                  className="wishlist-row"
                  key={item.id}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "2.1fr 1fr 1fr 0.95fr 40px",
                    padding: "18px 28px",
                    borderBottom: "1px solid var(--gray05)",
                    alignItems: "center",
                    columnGap: "12px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "16px", minWidth: 0 }}>
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{ width: "72px", height: "72px", objectFit: "contain", flexShrink: 0 }}
                    />
                    <Text size="px16" weight="w400" color="gray9">
                      {item.name}
                    </Text>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <Text size="px16" weight="w500" color="gray9">
                      {formatCurrency(item.price)}
                    </Text>
                    {item.hasDiscount ? (
                      <Text
                        size="px14"
                        weight="w400"
                        color="gray4"
                        extraStyles={{ textDecoration: "line-through" }}
                      >
                        {formatCurrency(item.originalPrice)}
                      </Text>
                    ) : null}
                  </div>

                  <span
                    style={{
                      display: "inline-flex",
                      width: "fit-content",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      backgroundColor: isInStock ? "#EAF7E9" : "#FDEDED",
                      color: isInStock ? "var(--primary)" : "#EA4B48",
                      fontSize: "14px",
                      fontWeight: 400,
                    }}
                  >
                    {isInStock ? "In Stock" : "Out of Stock"}
                  </span>

                  <Button
                    size="small"
                    variant={isInStock ? "fill" : "white"}
                    onClick={() => {
                      if (!isInStock) {
                        return;
                      }

                      addToCart(item);
                    }}
                    style={{
                      minWidth: "130px",
                      justifySelf: "start",
                      cursor: isInStock ? "pointer" : "not-allowed",
                      opacity: isInStock ? 1 : 0.55,
                    }}
                  >
                    Add to Cart
                  </Button>

                  <button
                    type="button"
                    onClick={() => toggleWishlist(item)}
                    style={{
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      border: "1px solid var(--gray2)",
                      backgroundColor: "var(--white)",
                      color: "var(--gray4)",
                      fontSize: "16px",
                      lineHeight: 1,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: 0,
                    }}
                  >
                    x
                  </button>
                </div>
              );
            })}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "20px 28px",
              }}
            >
              <Text size="px14" weight="w400" color="gray5">
                Share:
              </Text>
              <img
                src={socialMedias}
                alt="Social media"
                style={{ width: "184px", height: "40px", objectFit: "contain" }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
